import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../../services/api';

const RegisterPartner = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    first_name: '',
    last_name: '',
    phone: '',
    country_code: 'FR',
    company_name: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.password !== formData.confirmPassword) {
      setError('Les mots de passe ne correspondent pas');
      return;
    }

    if (formData.password.length < 8) {
      setError('Le mot de passe doit contenir au moins 8 caractères');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await API.post('/auth/partner/register', {
        email: formData.email,
        password: formData.password,
        first_name: formData.first_name,
        last_name: formData.last_name,
        phone: formData.phone,
        country_code: formData.country_code,
        company_name: formData.company_name
      });

      console.log('✅ Inscription réussie:', response.data);
      
      navigate('/login/partner', { 
        state: { 
          message: 'Inscription réussie ! En attente de validation.' 
        }
      });
      
    } catch (err) {
      console.error('❌ Erreur:', err);
      setError(
        err.response?.data?.error || 
        err.response?.data?.message ||
        'Erreur lors de l\'inscription'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Inscription Partenaire</h1>
        
        {error && <div style={styles.error}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div style={styles.row}>
            <input
              type="text"
              name="first_name"
              placeholder="Prénom *"
              value={formData.first_name}
              onChange={handleChange}
              required
              style={styles.halfInput}
            />
            
            <input
              type="text"
              name="last_name"
              placeholder="Nom *"
              value={formData.last_name}
              onChange={handleChange}
              required
              style={styles.halfInput}
            />
          </div>

          <input
            type="email"
            name="email"
            placeholder="Email professionnel *"
            value={formData.email}
            onChange={handleChange}
            required
            style={styles.input}
          />

          <input
            type="text"
            name="company_name"
            placeholder="Nom de l'entreprise *"
            value={formData.company_name}
            onChange={handleChange}
            required
            style={styles.input}
          />

          <input
            type="tel"
            name="phone"
            placeholder="Téléphone"
            value={formData.phone}
            onChange={handleChange}
            style={styles.input}
          />

          <select
            name="country_code"
            value={formData.country_code}
            onChange={handleChange}
            style={styles.input}
          >
            <option value="FR">France</option>
            <option value="TN">Tunisie</option>
            <option value="MA">Maroc</option>
            <option value="DZ">Algérie</option>
            <option value="BE">Belgique</option>
          </select>

          <input
            type="password"
            name="password"
            placeholder="Mot de passe * (min. 8 caractères)"
            value={formData.password}
            onChange={handleChange}
            required
            style={styles.input}
          />

          <input
            type="password"
            name="confirmPassword"
            placeholder="Confirmer le mot de passe *"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
            style={styles.input}
          />

          <button 
            type="submit" 
            disabled={loading}
            style={styles.button}
          >
            {loading ? 'Inscription...' : "S'inscrire"}
          </button>
        </form>

        <p style={styles.link}>
          Déjà un compte ?{' '}
          <span 
            onClick={() => navigate('/login/partner')}
            style={styles.linkSpan}
          >
            Se connecter
          </span>
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f5f5f5',
    padding: '1rem'
  },
  card: {
    backgroundColor: 'white',
    padding: '2rem',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    width: '100%',
    maxWidth: '500px'
  },
  title: {
    textAlign: 'center',
    marginBottom: '1.5rem',
    color: '#333'
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '1rem'
  },
  input: {
    width: '100%',
    padding: '0.75rem',
    marginBottom: '1rem',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '1rem',
    boxSizing: 'border-box'
  },
  halfInput: {
    width: '100%',
    padding: '0.75rem',
    marginBottom: '1rem',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '1rem',
    boxSizing: 'border-box'
  },
  button: {
    width: '100%',
    padding: '0.75rem',
    backgroundColor: '#0066FF',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    fontSize: '1rem',
    cursor: 'pointer',
    marginBottom: '1rem'
  },
  error: {
    backgroundColor: '#ffebee',
    color: '#c62828',
    padding: '0.75rem',
    borderRadius: '4px',
    marginBottom: '1rem',
    textAlign: 'center'
  },
  link: {
    textAlign: 'center',
    color: '#666'
  },
  linkSpan: {
    color: '#0066FF',
    cursor: 'pointer',
    textDecoration: 'underline'
  }
};

export default RegisterPartner;